import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadEnglishLevelFilterConfig } from '../../../configs/lead-english-level-filter-config';

export const LeadEnglishLevelFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='English Lvl'
      config={leadEnglishLevelFilterConfig}
    />
  );
};
